<template>
  <SogCard>
    <SogCardTitle>
      {{ data.id }}
      <template #SubTitle>
        {{ data.description }}
      </template>
    </SogCardTitle>
    <SogCardContent>
      <table>
        <tr>
          <td>Benutzername</td>
          <td>
            <SogDataLabel :value="data?.userName" />
          </td>
        </tr>
        <tr>
          <td>Addresse</td>
          <td>
            <SogDataLabel :value="data?.address" />
          </td>
        </tr>
        <tr>
          <td>Modus</td>
          <td>
            <SogDataLabel :value="data?.mode" />
          </td>
        </tr>
        <tr>
          <td>Kommunikationpartner Id</td>
          <td>
            <SogDataLabel :value="data?.communicationPartnerIdentifer" />
          </td>
        </tr>
        <tr>
          <td>Logintoken</td>
          <td>
            <SogDataLabel :value="data?.loginToken" />
          </td>
        </tr>
        <tr>
          <td>Logintoken gültig bis</td>
          <td>
            <SogDataLabel
              :value="data?.logingTokenValidityDate"
              :value-type="SogDataLabelValueType.DateTime"
            />
          </td>
        </tr>
        <tr>
          <td>Letzes Loginversuch</td>
          <td>
            <SogDataLabel
              :value="data?.lastLoginDate"
              :value-type="SogDataLabelValueType.DateTime"
            />
          </td>
        </tr>
        <tr>
          <td>Pin Fehlversuche</td>
          <td>
            <SogDataLabel :value="data?.pinError" />
          </td>
        </tr>
        <tr>
          <td>PIN erlaubte Fehlversuche</td>
          <td>
            <SogDataLabel :value="data?.pinErrorAllowed" />
          </td>
        </tr>
        <tr>
          <td>Gesperrt</td>
          <td>
            <SogDataLabel :value="data?.accountBlockedText" />
          </td>
        </tr>
        <tr>
          <td>Aktiv</td>
          <td>
            <span
              v-show="data?.active"
              class="e-badge e-badge-success e-badge-pill"
            >ja</span><span
              v-show="!data?.active"
              class="e-badge e-badge-danger e-badge-pill"
            >nein</span>
          </td>
        </tr>
        <tr>
          <td>Pin-Gültigkeit</td>
          <td>
            <SogDataLabel :value="data?.pinValidity" />
            <SogDataLabel value="Tag(e)" />
          </td>
        </tr>
        <tr>
          <td>Status</td>
          <td>
            <SogDataLabel :value="data?.statusText" />
          </td>
        </tr>
        <tr>
          <td>Briefkasten</td>
          <td>
            <span
              v-show="data?.briefkasten"
              class="e-badge e-badge-success e-badge-pill"
            >ja</span><span
              v-show="!data?.briefkasten"
              class="e-badge e-badge-danger e-badge-pill"
            >nein</span>
          </td>
        </tr>
        <tr>
          <td>Transferbriefkasten Ids</td>
          <td>
            <SogDataLabel :value="data?.transferBriefkastenIds" />
          </td>
        </tr>
      </table>
    </SogCardContent>
    <slot />
  </SogCard>
</template>

<script setup lang="ts">

import SogCard from "@/shared/ui/SogCard.vue";
import SogCardTitle from "@/shared/ui/SogCardTitle.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import GdvAccess from "@/shared/model/GdvAccess";
import SogDataLabel from "@/shared/ui/SogDataLabel.vue";
import {SogDataLabelValueType} from "@/shared/ui/types/SogDataLabelValueType";

interface Props {
  data?:GdvAccess
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = withDefaults(defineProps<Props>(), {
      data:undefined
    }
)

</script>

<style scoped>
td {
  padding-right: 12px;
}
</style>
